export { VpAppBar } from './VpAppBar';



// WEBPACK FOOTER //
// ./src/vp-ui/layout/VpAppBar/index.js